import { textAlignmentMap } from "../../content/configuration";
import { useResizeObserverWidth } from "../utils";
import WebsiteWidthContext from "./WebsiteWidthContext";
import { css } from "@emotion/react";
import { styleUtils, theme } from "@minted/minted-components";
import React, { memo, ReactNode } from "react";

const wrapperStyles = (isMobile: boolean, isPreviewMobile: boolean) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.x4};
  margin-left: ${isPreviewMobile ? theme.spacing.x3 : theme.spacing.x5};
  margin-right: ${isPreviewMobile ? theme.spacing.x3 : theme.spacing.x5};
  ${
    isMobile &&
    css`
      padding-bottom: ${styleUtils.rem(72)};
    `
  }
`;

export type DisplayWrapperProps = {
  children: ReactNode;
  isMobile: boolean;
  textAlignment: string;
};

const DisplayWrapper = ({
  children,
  isMobile,
  textAlignment,
}: DisplayWrapperProps) => {
  const { ref, width } = useResizeObserverWidth();
  const isPreviewMobile: boolean = width !== null && width < 600;

  return (
    <WebsiteWidthContext.Provider value={width}>
      <div
        css={[
          wrapperStyles(isMobile, isPreviewMobile),
          textAlignmentMap.get(textAlignment),
        ]}
        ref={ref}
      >
        {children}
      </div>
    </WebsiteWidthContext.Provider>
  );
};

const MemoizedDisplayWrapper = memo(DisplayWrapper);

export { MemoizedDisplayWrapper as DisplayWrapper };
